// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__S04rS","servText":"services_servText__ziaz9","mainDiv":"services_mainDiv__0+O5b"};